var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixHeadlessV1OAuthApp from '@wix/ambassador-headless-v1-o-auth-app/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
let __verbose = false;
function __log(...args) {
    __verbose && console.log(...args);
}
function __inspect(obj) {
    return obj;
}
export const __debug = {
    verboseLogging: {
        on: () => (__verbose = true),
        off: () => (__verbose = false),
    },
};
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
const _createOAuthAppRequest = {};
const _createOAuthAppResponse = {};
const _deleteOAuthAppRequest = {};
const _deleteOAuthAppResponse = {};
const _getOAuthAppRequest = {};
const _getOAuthAppResponse = {};
const _queryOAuthAppsRequest = {};
const _queryOAuthAppsResponse = {};
const _updateOAuthAppRequest = {};
const _updateOAuthAppResponse = {};
/**
 * Creates a new OAuth app for a Wix Headless client.
 *
 *
 * An OAuth app authorizes an external client app or site, on any platform, to authenticate with a Wix site or project and manage its data.
 *
 * > **Note:** The OAuth app secret is returned only when creating the OAuth app, and can't be retrieved later. Store the secret in a secure location.
 * @param oAuthApp - OAuth app to create.
 * @public
 * @documentationMaturity preview
 * @requiredField oAuthApp
 * @requiredField oAuthApp.name
 * @returns Created OAuth app info.
 */
export function createOAuthApp(oAuthApp) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { oAuthApp: '$[0]' };
        const responseTransformation = '$.oAuthApp';
        // @ts-ignore
        const { httpClient, sideEffects } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createOAuthAppRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['oAuthApp']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createOAuthAppResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['oAuthApp']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([oAuthApp]);
        const reqOpts = ambassadorWixHeadlessV1OAuthApp.createOAuthApp(payload);
        __log(`"CreateOAuthApp" sending request with: ${__inspect(reqOpts)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOpts);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'oAuthApp',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves an OAuth app by ID.
 * @param oAuthAppId - ID of the OAuth app to retrieve.
 * @public
 * @documentationMaturity preview
 * @requiredField oAuthAppId
 * @returns Retrieved OAuth app info.
 */
export function getOAuthApp(oAuthAppId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { oAuthAppId: '$[0]' };
        const responseTransformation = '$.oAuthApp';
        // @ts-ignore
        const { httpClient, sideEffects } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getOAuthAppRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getOAuthAppResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['oAuthApp']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([oAuthAppId]);
        const reqOpts = ambassadorWixHeadlessV1OAuthApp.getOAuthApp(payload);
        __log(`"GetOAuthApp" sending request with: ${__inspect(reqOpts)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOpts);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'oAuthAppId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates an OAuth app.
 *
 *
 * Only fields provided in `mask` are updated.
 *
 * You can update the following fields:
 * + `name`
 * + `description`
 * + `allowedDomain`
 * + `loginUrl`
 * @param _id - ID of the OAuth app.
 * @param mask - Explicit list of fields to update. Only fields listed are updated.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField mask
 * @requiredField oAuthApp
 * @returns Updated OAuth app info.
 */
export function updateOAuthApp(_id, oAuthApp, mask) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            oAuthApp: { '*': '$[1]', id: '$[0]' },
            mask: '$[2]',
        };
        const responseTransformation = '$.oAuthApp';
        // @ts-ignore
        const { httpClient, sideEffects } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateOAuthAppRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['oAuthApp']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateOAuthAppResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['oAuthApp']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, oAuthApp, mask]);
        const reqOpts = ambassadorWixHeadlessV1OAuthApp.updateOAuthApp(payload);
        __log(`"UpdateOAuthApp" sending request with: ${__inspect(reqOpts)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOpts);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'oAuthApp',
                'mask',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes an OAuth app by ID.
 *
 *
 * > **Note:** After you delete an OAuth app, an external client can no longer make API calls by authenticating with its client ID.
 * @param oAuthAppId - ID of the OAuth app to delete.
 * @internal
 * @documentationMaturity preview
 * @requiredField oAuthAppId
 */
export function deleteOAuthApp(oAuthAppId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { oAuthAppId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteOAuthAppRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteOAuthAppResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([oAuthAppId]);
        const reqOpts = ambassadorWixHeadlessV1OAuthApp.deleteOAuthApp(payload);
        __log(`"DeleteOAuthApp" sending request with: ${__inspect(reqOpts)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOpts);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'oAuthAppId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of OAuth apps, given the provided paging, filtering, and sorting.
 *
 *
 * Query OAuth Apps runs with these defaults, which you can override:
 * + Results are sorted by `id` in descending order.
 * + `paging.offset` is `0`.
 * @public
 * @documentationMaturity preview
 */
export function queryOAuthApps() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.oAuthApps',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryOAuthAppsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryOAuthAppsResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#oAuthApps']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixHeadlessV1OAuthApp.queryOAuthApps(payload);
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOpts);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'OFFSET',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
//# sourceMappingURL=headless-v1-o-auth-app.universal.js.map